import React from 'react';

/**
 * Simple MFA Recovery Link component
 * Can be used in Login, MFAVerification, or other auth components
 */
const MFARecoveryLink = ({ 
  className = "",
  text = "Can't access your device? Get help recovering your account",
  linkClass = "text-sm text-blue-600 hover:text-blue-500 underline"
}) => {
  return (
    <div className={`text-center ${className}`}>
      <a 
        href="/mfa/recovery/request" 
        className={linkClass}
      >
        {text}
      </a>
    </div>
  );
};

export default MFARecoveryLink;
